import styled from 'styled-components';

export const FormContainer = styled.div`
    margin: 1rem auto;
     .error {
        border: ${({ theme }) => `1px solid ${theme.dangerMain}`};
        color: ${({ theme }) => theme.dangerMain}};
    }
`;

const BaseStyledField = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1rem;

    .gi-input,
    .gi-component,
    .grid-row {
        .gi-input__label,
        .usa-legend {
            letter-spacing: 0;
            float: left;
            text-align: left;
            font-size: medium;
            font-weight: normal;
            margin-bottom: 1rem;
        }

        input,
        .usa-list {
            display: flex;
            flex-direction: column;
            justify-content: end;
            width: 280px;
        }

        .gi-textarea__input {
            width: 100%;
        }

        .gi-textarea__label {
            width: 100%;
            text-align: left;
            padding-left: 0;
        }

        .gi-input__input {
            margin-bottom: 1rem;
        }

        .react-datepicker-wrapper {
            margin-bottom: 1rem !important;
        }

        @media (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
            padding: 1rem;

            .gi-input__input,
            .gi-input__label,
            .usa-legend,
            input,
            select,
            .usa-list,
            .react-datepicker-wrapper {
                min-width: 100%;
                text-align: left !important;
            }
        }
    }

    &.ml-2 {
        .error--msg {
            margin-left: 2rem;
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        gap: 0;
        margin-top: 0;
    }
`;

export const StyledField = styled(BaseStyledField)`
    &.input-sm .gi-input input {
        width: 15rem;
    }
    .gi-input,
    .gi-component,
    .grid-row {
        display: flex;
        justify-content: center;
        margin-top: 0 !important;
        .gi-input__label,
        .usa-legend {
            font-size: 1.6rem;
            padding: 0 1rem;
            text-align: right;
            font-weight: 500;
            width: 300px !important;
            margin-right: 1rem;
        }

        input,
        .usa-list {
            width: 216px;
        }
    }

    .date-picker,
    .shown.error--msg {
        display: flex;
        align-items: center;
        @media (max-width: 768px) {
            margin-left: 1rem;
        }
    }

    .react-datepicker__view-calendar-icon {
        input {
            padding-left: 0.5rem;
        }
    }
`;

export const StyledFieldModal = styled(BaseStyledField)`
    display: flex;
    flex-direction: column;
    gap: 0;
    .gi-input,
    .gi-component,
    .grid-row {
        margin-top: 0;
        .gi-input__label,
        .usa-legend {
            font-size: medium;
            text-align: left;
            font-weight: normal;
            margin-bottom: 1rem;
        }

        input,
        .usa-list {
            width: 280px;
        }
    }
`;

export const ButtonContainer = styled.div`
    border-top: 1px solid ${({ theme }) => theme.gray5};
    display: flex;
    justify-content: center;
    padding-top: 2rem;
    margin-top: 1rem;
    .gi-button {
        text-transform: uppercase;
        margin-right: 18rem;
    }
    @media (max-width: 768px) {
        width: 100%;
        padding: 1rem;
        margin: 0;
        .gi-button {
            margin-right: 0;
        }
    }
`;

export const StyledParagraph = styled.p`
    padding-bottom: 0.5rem;
    @media (max-width: 768px) {
        margin-left: 1rem;
    }
`;

export const StyledContainer = styled.div`
    background-color: ${({ theme }) => theme.white};
`;

export const StyledHeaderContainer = styled.div`
    margin-bottom: 1rem;
`;

export const StyledTitle = styled.h4`
    border-radius: 0;
    padding-left: 1rem;
`;

export const StyledNoteSection = styled.div`
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    background-color: ${({ theme }) => `${theme.infoLighter}`};
    margin-top: 2rem;
    margin-bottom: 2rem;
`;

export const StyledModalBody = styled.div`
    .gi-modal__content {
        width: 60rem;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
`;

export const StyledCharacterCounter = styled.div`
    margin-bottom: 0.5rem;
`;
